export * from './logo.component'
export * from './logo.component.types'
